import axios from 'axios';

import {
  SET_BOOKING_AVAIL_DATES,
  SET_BOOKING_UNAVAIL_DATES,
  SET_BOOKING_DATE,
  SET_BOOKING_PAX,
  SET_BOOKING_VEHICLE,
  SET_BOOKING_MEETING_POINT,
  SET_BOOKING_PRICE,
  SET_BOOKING_FORM_DATA,
  SET_BOOKING_PRIMARY_DRIVER,
  SET_BOOKING_STEP,
  SET_DATE_WAS_RESET,
  REQUEST_BOOKING_INFO,
  RECEIVE_BOOKING_INFO,
  REQUEST_PRICING_INFO,
  RECEIVE_PRICING_INFO,
  REQUEST_BOOKING_STATUS,
  RECEIVE_BOOKING_STATUS,
  REQUEST_BOOKING_COMPANIONS,
  RECEIVE_BOOKING_COMPANIONS,
  TOGGLE_PROCEED_TO_PAYMENT,
  TOGGLE_AGREE_CANCELLATION_POLICY,
  SEND_BOOKING_FORM,
  SEND_BOOKING_FORM_WITH_AUTH,
  RECEIVE_BOOKING_FORM_RESPONSE,
  CLEAR_PAYMENT_DATA,
  CLEAR_BOOKING_FORM_DATA,
  SEND_COMPANION_FORM,
  RECEIVE_COMPANION_FORM_RESPONSE,
  SEND_SAVE_FOR_LATER,
  RECEIVE_SAVE_FOR_LATER_RESPONSE,
  REQUEST_SAVED_INFO,
  RECEIVE_SAVED_INFO,
  REQUEST_DELETE_SAVED_INFO,
  RECEIVE_DELETE_SAVED_INFO,
  RECEIVE_BYOR_IS_MEMBER_RESPONSE,
  REQUEST_BYOR_IS_MEMBER,
  SET_BYOR_VEHICLE_NO,
  SET_VEHICLE_NO_AND_MODEL,
  RESET_BYOR
} from '../constants/actionTypes';

import { receiveErrorResponse } from './api';

import { completeSignOut } from './auth';

import { promoClickGA } from '../js/analytics';

import i18next from 'i18next';

import api, { apiAuth } from '../api';
import {
  fakeBookingApi2,
  updatedFakeBookingApi
} from '../constants/fakeBooking';
import { fakeBookingSummaryApi } from '../constants/fakeBookingSummary';
import { fakeCompanionsApi } from '../constants/fakeCompanions';
import { fakeCompanionStatusApi } from '../constants/fakeCompanionStatus';
import { fakePricingApi } from '../constants/fakePricing';
import {
  fakeSavedBookingStep1,
  fakeSavedBookingStep2,
  fakedSaveForLaterResponse
} from '../constants/fakeSavedBooking';

export const setBookingAvailDates = dates => ({
  type: SET_BOOKING_AVAIL_DATES,
  dates
});

export const setBookingUnavailDates = dates => ({
  type: SET_BOOKING_UNAVAIL_DATES,
  dates
});

export const setBookingDate = date => ({
  type: SET_BOOKING_DATE,
  date
});

export const setBookingPax = pax => {
  const parsedPax = parseInt(pax);
  return {
    type: SET_BOOKING_PAX,
    pax: isNaN(parsedPax) ? pax : parsedPax
  };
};

export const setBookingVehicle = (id, name, reset = false) => ({
  type: SET_BOOKING_VEHICLE,
  id: parseInt(id),
  name,
  reset
});

export const setMeetingPoint = (id, name, reset = false) => ({
  type: SET_BOOKING_MEETING_POINT,
  id: parseInt(id),
  name,
  reset
});

export const setBookingFormData = data => ({
  type: SET_BOOKING_FORM_DATA,
  data
});

export const setDateWasReset = bool => ({
  type: SET_DATE_WAS_RESET,
  bool
});

export const clearBookingFormData = () => ({
  type: CLEAR_BOOKING_FORM_DATA
});

export const setBookingPrimaryDriver = bool => ({
  type: SET_BOOKING_PRIMARY_DRIVER,
  bool
});

export const setBookingPrice = priceObj => ({
  type: SET_BOOKING_PRICE,
  bookingPrice: priceObj
});

export const setBookingStep = step => ({
  type: SET_BOOKING_STEP,
  step: parseInt(step)
});

export const requestBookingInfo = () => ({
  type: REQUEST_BOOKING_INFO
});

export const receiveBookingInfo = response => ({
  type: RECEIVE_BOOKING_INFO,
  response
});

export const requestPricingInfo = () => ({
  type: REQUEST_PRICING_INFO
});

export const receivePricingInfo = response => ({
  type: RECEIVE_PRICING_INFO,
  response
});

export const sendBookingForm = () => ({
  type: SEND_BOOKING_FORM
});

export const sendBookingFormWithAuth = () => ({
  type: SEND_BOOKING_FORM_WITH_AUTH
});

export const receiveBookingFormResponse = response => ({
  type: RECEIVE_BOOKING_FORM_RESPONSE,
  response
});

export const toggleAgreeCancellationPolicy = bool => ({
  type: TOGGLE_AGREE_CANCELLATION_POLICY,
  bool
});

export const toggleProceedToPayment = bool => ({
  type: TOGGLE_PROCEED_TO_PAYMENT,
  bool
});

export const clearPaymentData = () => ({
  type: CLEAR_PAYMENT_DATA
});

export const requestBookingStatus = () => ({
  type: REQUEST_BOOKING_STATUS
});

export const receiveBookingStatus = response => ({
  type: RECEIVE_BOOKING_STATUS,
  response
});

export const requestBookingCompanions = () => ({
  type: REQUEST_BOOKING_COMPANIONS
});

export const receiveBookingCompanions = response => ({
  type: RECEIVE_BOOKING_COMPANIONS,
  response
});

export const sendCompanionForm = () => ({
  type: SEND_COMPANION_FORM
});

export const receiveCompanionFormResponse = response => ({
  type: RECEIVE_COMPANION_FORM_RESPONSE,
  response
});

export const sendSaveForLater = () => ({
  type: SEND_SAVE_FOR_LATER
});

export const receiveSaveForLaterResponse = response => ({
  type: RECEIVE_SAVE_FOR_LATER_RESPONSE,
  response
});

export const requestSavedInfo = () => ({
  type: REQUEST_SAVED_INFO
});

export const receiveSavedInfo = response => ({
  type: RECEIVE_SAVED_INFO,
  response
});

export const requestDeleteSavedInfo = () => ({
  type: REQUEST_DELETE_SAVED_INFO
});

export const receiveDeleteSavedInfo = response => ({
  type: RECEIVE_DELETE_SAVED_INFO,
  response
});

export const requestByorIsMember = () => ({
  type: REQUEST_BYOR_IS_MEMBER
});

export const receiveByorIsMemberResponse = response => ({
  type: RECEIVE_BYOR_IS_MEMBER_RESPONSE,
  response
});

export const setByorVehicleNo = no => ({
  type: SET_BYOR_VEHICLE_NO,
  no
});

export const setVehicleNoAndModel = (no, model) => ({
  type: SET_VEHICLE_NO_AND_MODEL,
  no,
  model
});

export const resetByor = () => ({
  type: RESET_BYOR
});

// Prod
export function fetchBookingInfo(slug, totalPax, date, meetingPointId = '') {
  return function (dispatch) {
    dispatch(requestBookingInfo());
    let apiStr = `/v1/booking/trip/${slug}/step/1`;
    if (date) {
      apiStr = apiStr.concat(`?tour_date=${date}`);
      if (meetingPointId !== '') {
        apiStr = apiStr.concat(`&meeting_point=${meetingPointId}`);
      }
    } else if (meetingPointId !== '') {
      apiStr = apiStr.concat(`?meeting_point=${meetingPointId}`);
    }
    if (totalPax){
      apiStr = apiStr.concat(`&totalPax=${totalPax}`);
    }
    return api
      .get(apiStr)
      .then(response => {
        dispatch(receiveBookingInfo(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// For testing
// export function fetchBookingInfo(slug) {
//   return function(dispatch) {
//     dispatch(requestBookingInfo());
//     return new Promise((resolve, reject) => {
//       setTimeout(resolve, 1000);
//       //setTimeout(reject(new Error('could not receive data!')), 1000);
//     })
//       .then(() => dispatch(receiveBookingInfo(fakeBookingApi2)))
//       .catch(err => dispatch(receiveBookingInfoFailure(err)));
//   };
// }

// Prod
export function updateBookingInfo(
  slug,
  date,
  vehicleId,
  vehicleName,
  meetingPointId = ''
) {
  return function (dispatch) {
    let apiStr = `/v1/booking/trip/${slug}/step/1`;
    if (date) {
      dispatch(setBookingDate(date));
      apiStr = apiStr.concat(`?tour_date=${date}`);
      if (meetingPointId) {
        apiStr = apiStr.concat(`&meeting_point=${meetingPointId}`);
      }
    }
    dispatch(requestBookingInfo());
    return api
      .get(apiStr)
      .then(response => {
        const { data } = response;
        // For testing -> const data = updatedFakeBookingApi;
        dispatch(receiveBookingInfo(data));
        //Set meeting point to first available if previously picked unavailable
        const currMeetingPoint = data.meeting_points.find(
          mp => mp.id === meetingPointId
        );

        if (currMeetingPoint.is_available !== true) {
          const firstAvailMeetingPoint = data.meeting_points.find(
            mp => mp.selected
          );
          if (!firstAvailMeetingPoint) {
            const errorObj = {
              response: {
                status: 403,
                data: {
                  message: i18next.t('error:tripNotAvailable')
                }
              }
            };
            dispatch(receiveErrorResponse(errorObj));
            return;
          } else {
            dispatch(
              setMeetingPoint(
                firstAvailMeetingPoint.id,
                firstAvailMeetingPoint.name,
                true
              )
            );
          }
        }
        //If not BYOC
        if (!data.is_own_vehicle) {
          //Set vehicle to first available vehicle if previously picked vehicle is unavailable
          const currVehicle = data.vehicle_selection.find(
            vehicle => vehicle.title === vehicleName
          );
          if (!currVehicle || currVehicle.is_available !== true) {
            const firstAvailVehicle = data.vehicle_selection.find(
              vehicle => vehicle.is_available === true
            );
            dispatch(
              setBookingVehicle(
                firstAvailVehicle.id,
                firstAvailVehicle.title,
                true
              )
            );
            //If not, check if vehicle ID has changed due to different meeting point and set it to that
          } else if (currVehicle.id !== vehicleId) {
            dispatch(setBookingVehicle(currVehicle.id, currVehicle.title));
          }
        }
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// Prod
export function fetchPricingInfo(
  slug,
  pax,
  promoCode = '',
  email = null,
  isByPax = false,
  byor,
  date
) {
  return function (dispatch) {
    let child = 0;
    let adult = 0;
    if (isByPax) {
      child = pax.child;
      adult = pax.adult ? pax.adult : pax;
      pax = 0;
    } else if (typeof pax !== 'number') {
      child = pax.child;
      adult = pax.adult;
      pax = 0;
    }
    if (child === undefined){
      child = 0;
    }
    dispatch(requestPricingInfo());
    let apiStr = `/v1/price-summary?uuidSlug=${slug}&pax_no=${pax}&child=${child}&adult=${adult}&promo_code=${promoCode}&byor=${byor}&tour_date=${date}`;
    if (email) {
      apiStr = apiStr.concat(`&email=${email}`);
    }
    return api
      .get(apiStr)
      .then(response => {
        // Track promo code click analytics if valid
        if (promoCode !== '' && response.data.discount.is_valid) {
          promoClickGA(promoCode);
        }
        dispatch(receivePricingInfo(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// Test
// export function fetchPricingInfo(slug = '', pax=1) {
//     return function(dispatch) {
//         dispatch(requestPricingInfo());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 3000);
//         })
//             .then(() => dispatch(receivePricingInfo(fakePricingApi)))
//             .catch((err) => dispatch(receiveErrorResponse(err)));
//     }
// }

// Prod
export function postBookingForm(slug, formData, xcsrfToken) {
  return function (dispatch) {
    dispatch(sendBookingForm());
    var headers = {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': xcsrfToken
    };
    return api
      .post(`/v1/booking/trip/${slug}/step/2`, formData, { headers: headers })
      .then(response => {
        dispatch(receiveBookingFormResponse(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

export function postBookingFormWithAuth(slug, formData, xcsrfToken) {
  return function (dispatch) {
    dispatch(sendBookingFormWithAuth());
    return apiAuth(
      `/v1/booking/trip/${slug}/step/2`,
      'post',
      xcsrfToken,
      formData
    )
      .then(response => {
        dispatch(receiveBookingFormResponse(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

export function postSaveForLater(formData, xcsrfToken) {
  return function (dispatch) {
    dispatch(sendSaveForLater());
    return apiAuth('/v1/save-later', 'post', xcsrfToken, formData)
      .then(response => {
        dispatch(receiveSaveForLaterResponse(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

export function updateSaveForLater(formData, xcsrfToken, uuid) {
  return function (dispatch) {
    dispatch(sendSaveForLater());
    return apiAuth(`/v1/save-later/${uuid}`, 'put', xcsrfToken, formData)
      .then(response => {
        dispatch(receiveSaveForLaterResponse(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

export function deleteSavedInfo(xcsrfToken, uuid) {
  return function (dispatch) {
    dispatch(requestDeleteSavedInfo());
    return apiAuth(`/v1/save-later/${uuid}`, 'delete', xcsrfToken)
      .then(response => {
        dispatch(receiveDeleteSavedInfo(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

export function fetchSavedInfo(uuid) {
  return function (dispatch) {
    dispatch(requestSavedInfo());
    return apiAuth(`/v1/save-later/${uuid}/continue`)
      .then(response => {
        dispatch(receiveSavedInfo(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
        if (err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

// Not needed probably
// export function postFormToIpay(formData) {
//     console.log(formData);
//     return function(dispatch) {
//         dispatch(sendDataToIpay());
//         var headers = {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/x-www-form-urlencoded',
//         };
//         return api88.post('', formData, { headers: headers })
//             .then((response) => {
//                 dispatch(receiveIpayResponse(response.data));
//             })
//             .catch((err) => {
//                 dispatch(receiveErrorResponse(err));
//             });
//     };
// }

// Prod
export function fetchBookingStatus() {
  return function (dispatch) {
    dispatch(requestBookingStatus());
    return api
      .get('/v1/booking/trip/step/3')
      .then(response => {
        dispatch(receiveBookingStatus(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// Test
// export function fetchBookingStatus() {
//     return function(dispatch) {
//         dispatch(requestBookingStatus());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 250);
//         })
//             .then(() => dispatch(receiveBookingStatus(fakeBookingSummaryApi)))
//             .catch((err) => dispatch(receiveErrorResponse(err)));
//     };
// }

// For prod
export function fetchBookingCompanions(params = '') {
  return function (dispatch) {
    dispatch(requestBookingCompanions());
    return api
      .get(`/v1/booking/companions${params}`)
      .then(response => {
        dispatch(receiveBookingCompanions(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// Test
// export function fetchBookingCompanions() {
//     return function(dispatch) {
//         dispatch(requestBookingCompanions());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 250);
//         })
//             .then(() => dispatch(receiveBookingCompanions(fakeCompanionsApi)))
//             .catch((err) => dispatch(receiveErrorResponse(err)));
//     };
// }

// Prod
export function postCompanionForm(formData, xcsrfToken, params = '') {
  return function (dispatch) {
    dispatch(sendCompanionForm());
    var headers = {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': xcsrfToken
    };
    return api
      .post(`/v1/booking/companions${params}`, formData, { headers: headers })
      .then(response => {
        dispatch(receiveCompanionFormResponse(response.data));
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// Test
// export function postCompanionForm(formData, xcsrfToken, params='', ) {
//     return function(dispatch) {
//         dispatch(sendCompanionForm());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 250);
//         })
//             .then(() => dispatch(receiveCompanionFormResponse(fakeCompanionStatusApi)))
//             .catch((err) => dispatch(receiveErrorResponse(err)));
//     };
// }

// export function postSaveForLater(formData, xcsrfToken) {
//     return function(dispatch) {
//         dispatch(sendSaveForLater());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 3000);
//         })
//             .then(() => dispatch(receiveSaveForLaterResponse(fakedSaveForLaterResponse)))
//             .catch((err) => dispatch(receiveErrorResponse(err)));
//     };
// }

// export function updateSaveForLater(formData, xcsrfToken, uuid='') {
//     return function(dispatch) {
//         dispatch(sendSaveForLater());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 3000);
//         })
//             .then(() => dispatch(receiveSaveForLaterResponse(fakedSaveForLaterResponse)))
//             .catch((err) => dispatch(receiveErrorResponse(err)));
//     };
// }

// export function fetchSavedInfo(uuid='') {
//     return function(dispatch) {
//         dispatch(requestSavedInfo());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 3000);
//         })
//             .then(() => dispatch(receiveSavedInfo(fakeSavedBookingStep1)))
//             .catch((err) => dispatch(receiveErrorResponse(err)));
//     };
// }

// Prod
export function verifyVehicleNo(param) {
  return function (dispatch) {
    dispatch(requestByorIsMember());
    const value = param.vehicleNo.replace(/\s/g, '');
    const raptor = param.raptorTrip;
    return api
      .get(`/v1/ford?registration_no=${value}&raptor_trip=${raptor}`)
      .then(res => {
        dispatch(receiveByorIsMemberResponse(res.data.isMember));
        dispatch(setByorVehicleNo(param.vehicleNo));
        return res.data.isMember;
      })
      .catch(err => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

// Test
// export function verifyVehicleNo(vehicleNo) {
//   return function(dispatch) {
//     dispatch(requestByorIsMember());
//     return new Promise((resolve, reject) => {
//       setTimeout(resolve, 3000);
//     })
//       .then(res => {
//         const isNotMember = {
//           status: 'done',
//           response: [
//             {
//               isMember: 'False'
//             }
//           ]
//         };
//         const isMember = {
//           status: 'done',
//           response: [
//             {
//               isMember: 'True'
//             }
//           ]
//         };
//         let member;
//         if (isMember.response[0].isMember === 'True') member = true;
//         if (isMember.response[0].isMember === 'False') member = false;
//         dispatch(receiveByorIsMemberResponse(member));
//         dispatch(setByorVehicleNo(vehicleNo));
//       })
//       .catch(err => {
//         dispatch(receiveErrorResponse(err));
//       });
//   };
// }
